import './style.scss'
import Phone from '../../Assets/img-phone.png'
import Logo from '../../Assets/logo.png'

export default function Home(){
    return(
        <div className="home-page">
            <div className='text'>
                <div>
                    <img src={Logo} alt='Logo'/>
                    <h1>CONEXTRA</h1>
                    <p>
                        Consultoria procesos MINTIC<br/>
                        y Transformación digital
                    </p>
                </div>
                <div>
                    <button>Contáctanos</button>
                </div>
            </div>
            <div className='img'>
                <div>
                    <img src={Phone}/>
                </div>
            </div>
        </div>
    )
}